import { useTranslation } from "react-i18next";
import { CheckCircle2, XCircle } from "lucide-react";
import Button from "../../../../components/shared/Button";
import Dialog from "../../../../components/shared/Dialog";
import SimpleTable from "../../../../components/SimpleTable";
import { useColumns } from "./columns";
import "./index.scss";

function InfoModal({ isOpen, values, close }: any) {
    const { t } = useTranslation();
    const columns = useColumns();
    const { type, data } = values || {};

    return (
        <Dialog
            title={t("info")}
            open={isOpen}
            size="4xl"
            close={close}
        >
            <div className="info-modal-table tw-mx-2 tw-my-4 tw-overflow-auto tw-max-h-[300px] tw-max-w-full tw-min-w-0">
                {type === "import" ? Object.keys(data || {}).map((employeeNumber) => {
                    const { status, message, ...rows } = data[employeeNumber];
                    const { inserted, failed } = Object
                        .entries(rows)
                        .reduce(
                            (total: any, [row, value]: any) => {
                                if (value.status) {
                                    total.inserted[row] = value;
                                } else {
                                    total.failed[row] = value;
                                }
                                return total;
                            },
                            { inserted: {}, failed: {} }
                        );

                    return (
                        <div
                            key={employeeNumber}
                            className="tw-p-3 tw-rounded tw-mb-4"
                            style={{ backgroundColor: "#f7fafc" }}
                        >
                            <h3>
                                <span className="tw-mr-3">
                                    {employeeNumber === 'emptyUser' ? (
                                        t('other')
                                    ) : `${t("employee")} ${employeeNumber}`}
                                </span>

                                {status ? (
                                    <>
                                        {!!Object.keys(inserted).length && (
                                            <span className="text-success tw-mr-3">
                                                <CheckCircle2 />
                                                {Object.keys(inserted).length}
                                            </span>
                                        )}

                                        {!!Object.keys(failed).length && (
                                            <span className="text-danger tw-mr-3">
                                                <XCircle />
                                                {Object.keys(failed).length}
                                            </span>
                                        )}
                                    </>
                                ) : (
                                    <span className="text-danger">{message}</span>
                                )}
                            </h3>

                            {status && (
                                <div>
                                    {!!Object.keys(failed).length && (
                                        <hr className="tw-my-2" />
                                    )}

                                    {Object.keys(failed).map((row: any) => {
                                        return (
                                            <div key={row} className="text-danger">
                                                <b>{t("row-count", { count: row })}:</b>
                                                {" "}
                                                <span>{failed[row].message}</span>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    );
                }) : (
                    <SimpleTable
                        data={data || []}
                        columns={columns}
                        footer={false}
                        enableRowSelection={false}
                        loading={undefined}
                        getRowProps={undefined}
                    />
                )}
            </div>

            <div className="tw-flex tw-justify-end tw-m-4">
                <Button
                    type="button"
                    variant="outline"
                    onClick={close}
                >
                    {t("close")}
                </Button>
            </div>
        </Dialog>
    );
}

export default InfoModal;
